import { ReactComponent as TrackingSupportIcon } from 'assets/dialogue-avatar-tracking-support.svg';
import { extLnkPending } from 'config/track-config';
import { DialogueCardData, DialogueType } from 'models/DialogCard';
import { Milestone } from 'models/shipments';

import ArrowLink from './Arrows/ArrowLink';

export function getPendingExplainerCard(latestMilestone: string | null): DialogueCardData | null {
  if (latestMilestone && latestMilestone !== Milestone.PENDING) return null;
  return {
    analyticsId: 'pendingExplainer',
    icon: <TrackingSupportIcon />,
    type: DialogueType.TRACKING_SUPPORT,
    title: 'Try checking again in 24 hours',
    content: (
      <>
        <p>We haven’t received the full parcel details from the sender yet. We’ll let you know when we receive them.</p>
      </>
    ),
    actions: <ArrowLink href={extLnkPending}>Learn more</ArrowLink>,
  };
}
